export const ErrorCode = {
  Validation: 'VALIDATION_ERROR',
  NotFound: 'NOT_FOUND',
  Forbidden: 'FORBIDDEN',
  Unauthorized: 'UNAUTHORIZED',
  Internal: 'INTERNAL_ERROR',
  ServiceUnavailable: 'SERVICE_UNAVAILABLE',
  Conflict: 'CONFLICT',
  RateLimited: 'RATE_LIMITED',
  TwoFARequired: 'TWOFA_REQUIRED',
} as const

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode]

export interface ApiErrorBody {
  code: ErrorCode
  message: string
  details?: unknown
}

export interface ApiEnvelope<T = unknown> {
  data?: T
  error?: ApiErrorBody
  meta?: {
    total: number
    page: number
    limit: number
  }
}

const errorCodeFromStatus: Record<number, ErrorCode> = {
  400: ErrorCode.Validation,
  401: ErrorCode.Unauthorized,
  403: ErrorCode.Forbidden,
  404: ErrorCode.NotFound,
  409: ErrorCode.Conflict,
  429: ErrorCode.RateLimited,
  503: ErrorCode.ServiceUnavailable,
}

export class ApiError extends Error {
  readonly code: ErrorCode
  readonly status: number
  readonly requestId?: string

  constructor(code: ErrorCode, status: number, requestId?: string, message?: string) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.status = status
    this.requestId = requestId
  }

  static fromResponse(status: number, body: ApiEnvelope, requestId?: string): ApiError {
    const err = body?.error
    const code = err?.code ?? errorCodeFromStatus[status] ?? ErrorCode.Internal
    return new ApiError(code, status, requestId, err?.message ?? 'Unknown error')
  }
}

export function extractErrorMessage(err: unknown, fallback = 'Ошибка запроса'): string {
  if (err instanceof ApiError) return err.message
  if (err instanceof Error) return err.message
  return String(fallback)
}
